<template>
    <div class="container" v-loading="tableing">
        <div class="header">测评记录
            <el-button class="exit" size="mini" @click="exit()"><img src="../../../static/images/end-back.png" alt="" srcset=""> &nbsp; 返 回 </el-button>
        </div>
        <div class="main" ref="main">
            <div class="orgList" v-for="(item,index) in list" :key="index">
                <ul class="orgList_ul">
                    <li>{{item.paperName}}</li>
                    <li>
                        <span class="dyj" v-show="item.reviewStatus==0" style="line-height:55px">待阅卷</span>
                        <span v-show="item.reviewStatus==1">得分：{{item.userScore}}</span>
                    </li>
                    <li>{{item.examStartDateVal}}</li>
                    <li>
                        <el-button class="errorBtu" size="mini" @click="errorProblem(item)" v-show="item.reviewStatus!=0"> 错题库 </el-button>
                    </li>
                </ul>
            </div>
        </div>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="arrPage"
            :page-size="page.pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            class="pagin"
            style="text-align: center;">
        </el-pagination>
    </div>
</template>
<script>
    export default {
        name:"examList",
        data() {
            return {
                tableing:false,
                list:[],
                page:{
                    pageSize:10,
                    pageNum:1,  
                    total:null,
                },
                arrPage:[],
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.$nextTick(()=>{
                this.fooComput()
            })
            window.addEventListener('resize', () => this.fooComput(), false)
        },
        methods:{
            fooComput(){
                this.page.pageSize = Math.floor(this.$refs.main.clientHeight/80)
                this.arrPage = [
                    this.page.pageSize*1,
                    this.page.pageSize*2,
                    this.page.pageSize*3,
                    this.page.pageSize*4,
                    this.page.pageSize*5,
                    this.page.pageSize*10,
                ]
                this.getData()
            },
            handleSizeChange(val) {
                this.page.pageSize = val
                this.getData();
            },
            handleCurrentChange(val) {
                this.page.pageNum = val
                this.getData();
            },
            getData(){
                let that = this
                that.tableing = true
                that.$axios.post('/paper/acg/userPaperList',{
                    pageNum:that.page.pageNum,
                    pageSize:that.page.pageSize,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.list = v.data.list
                        that.page.total = v.data.total;
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            errorProblem(item){
                this.$router.push({
                    path: '/errProblem',
                    query: {
                        id:item.id,
                        paperId:item.paperId
                    }
                })
            },
            exit(){
                this.$router.go(-1)
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .pagin{
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        .exit{
            background-color: rgb(96,161,251);
            border: none;
            font-size: 13px;
            color: #fff;
            position: absolute;
            top: 16px;
            right: 10%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 60px;
        bottom: 50px;
        left: 0;
        right: 0;
        width: 100%;
        overflow-y: auto;
    }
    .orgList{
        background-color: rgb(246, 246, 246);
        height: 60px;
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); 
        position: relative;
        .orgList_ul{
            width: 100%;
            height: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 5px 50px;
            li{
                text-align: left;
                float: left;
                width: 50%;
                height: 50%;
            }
            li:nth-child(odd){
                text-align: left;
            }
            li:nth-child(even){
                text-align: right;
            }
            li:nth-child(1){
                font-size: 17px;
                font-weight: bold;
            }
            li:nth-child(2){
                font-size: 14.5px;
                color: #001E8C;
            }
            li:nth-child(3){
                font-size: 12.5px;
            }
            .errorBtu{
                background-color: #004CB3;
                color: #fff;
                padding-top: 6px;
                padding-bottom: 6px;
            }
            .dyj{
                color: red;
                font-weight: bold;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/examRecords/examRecords.vue